import axios from 'axios'
import { useUserStore } from '../stores/user'
import { URLs } from '@/constants'
import _ from 'lodash'
import { useAccountSettingsStore } from '@/stores/accountSettings'

const axiosInstance = axios.create({
  timeout: 10000,
  withCredentials: false,
  headers: { 'Content-Type': 'application/json' },
})

axiosInstance.interceptors.request.use(
  config => {
    const accountStore = useAccountSettingsStore()
    if (accountStore.sessionToken) {
      config.headers['Authorization'] =
        `Bearer ${_.trim(accountStore.sessionToken)}`
    }
    if (accountStore.accountId) {
      config.params.accountId = accountStore.accountId
    }
    return config
  },
  error => Promise.reject(error),
)

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // const userStore = useUserStore();
    // userStore.$reset();
    // localStorage.clear();
    // router.push('/');
    // window.location.href = "/";
    console.log('something wrong happens')
    if (error.response && error.response.status === 401) {
      // alert(error.response.status)
      // const userStore = useUserStore();
      // userStore.clearUser();
      // window.location.href = "/";
    }
    return Promise.reject(error)
  },
)

export default axiosInstance
